// src/pages/academy/components/RichText.jsx
// بيعرض HTML اللي طالع من الـ rich editor بعد تنضيفه بـ DOMPurify.
// npm i dompurify
import { useMemo } from "react";
import DOMPurify from "dompurify";

const HAS_TAGS = /<[a-z][\s\S]*>/i;

// Tailwind preflight بيلغي margins/lists، فبنرجّعها هنا عشان الشكل يطابق الـ editor
const BASE =
  "[&_p]:m-0 [&_p+p]:mt-1.5 " +
  "[&_ul]:list-disc [&_ul]:ps-5 [&_ol]:list-decimal [&_ol]:ps-5 " +
  "[&_img]:max-w-full [&_img]:rounded-lg " +
  "[&_a]:text-indigo-600 [&_a]:underline " +
  "[&_h1]:font-bold [&_h2]:font-bold [&_h3]:font-semibold [&_blockquote]:border-s-2 [&_blockquote]:ps-3";

export default function RichText({ html, className = "" }) {
  const clean = useMemo(() => DOMPurify.sanitize(html || ""), [html]);
  if (!clean) return null;

  // داتا قديمة اتخزنت نص عادي (من غير tags): نحافظ على الأسطر
  const legacy = !HAS_TAGS.test(clean) ? "whitespace-pre-wrap" : "";

  return (
    <div
      className={`${BASE} ${legacy} ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}

// نص صافي (للـ modal بتاع الحذف وأي مكان مش بيعرض HTML)
export const stripHtml = (s) =>
  (s || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();